export default __webpack_public_path__ + "static/media/icon_deleting.0731e045.svg";